/**
 * Alarm-log rows from the Alarm API are not zone-filtered server-side.
 * GET /sensors is zone-scoped for viewers — intersect so we never display
 * or act on alarms for sensors the user cannot see.
 */
export function filterAlarmLogsBySensorAccess<T extends { sensor_id?: unknown }>(
  logs: readonly T[] | undefined | null,
  sensors: readonly { id: unknown }[] | undefined | null
): T[] {
  if (!Array.isArray(logs) || logs.length === 0) return [];
  if (!Array.isArray(sensors) || sensors.length === 0) return [];
  const allowed = new Set(sensors.map((s) => Number(s.id)));
  return logs.filter((row) => allowed.has(Number(row.sensor_id)));
}
